import { type FormEventHandler, useCallback, useId } from "react";
import { useControl } from "../use-alk-maps";
import { stopArrowKeyPropagation } from "../utils";
import classes from "./map-nav.module.css";

type InteractionMode = "pan" | "zoom";

const zoomBox = () =>
	new window.ALKMaps.Control.ZoomBox({ autoActivate: false });

export function InteractionModes() {
	const id = useId();
	const control = useControl(zoomBox);

	const onInput = useCallback<FormEventHandler>(
		(event) => {
			const mode = (event.target as HTMLInputElement).value as InteractionMode;
			if (mode === "zoom") {
				control.activate();
			} else {
				control.deactivate();
			}
		},
		[control],
	);

	return (
		<div
			className={classes.section}
			onKeyDown={stopArrowKeyPropagation}
			onInput={onInput}
		>
			<label title={"Drag to Pan Mode"} className={classes.button}>
				<input
					className={classes.hiddenInput}
					type="radio"
					value="pan"
					name={id}
					defaultChecked
				/>
				<i className="ico ico-hand" />
			</label>
			<label title={"Drag to Zoom Mode"} className={classes.button}>
				<input
					className={classes.hiddenInput}
					type="radio"
					value="zoom"
					name={id}
				/>
				<i className="ico ico-box" />
			</label>
		</div>
	);
}
